var pug = require("!../../../../../node_modules/.pnpm/pug@2.0.4/node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (ariaLabel, columns, data, isForVNext) {pug_html = pug_html + "\u003Cdiv class=\"import-error-table error\" id=\"ImportErrorTable\" role=\"alert\"\u003E\u003Cdiv class=\"error import-error-message\"\u003E\u003C\u002Fdiv\u003E";
if (data && columns) {
pug_html = pug_html + "\u003Ctable" + (pug.attr("aria-label", ariaLabel, true, true)) + "\u003E\u003Cthead\u003E\u003Ctr class=\"grid-header-row\"\u003E";
// iterate columns
;(function(){
  var $$obj = columns;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var column = $$obj[pug_index0];
pug_html = pug_html + "\u003Cth class=\"grid-header-cell grid-disabledsort\"\u003E\u003Cdiv class=\"grid-header-textcontainer\"\u003E\u003Ca class=\"grid-header-text\" href=\"javascrit:void(0)\"\u003E" + (pug.escape(null == (pug_interp = column) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fth\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var column = $$obj[pug_index0];
pug_html = pug_html + "\u003Cth class=\"grid-header-cell grid-disabledsort\"\u003E\u003Cdiv class=\"grid-header-textcontainer\"\u003E\u003Ca class=\"grid-header-text\" href=\"javascrit:void(0)\"\u003E" + (pug.escape(null == (pug_interp = column) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fth\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ftr\u003E\u003C\u002Fthead\u003E\u003Ctbody\u003E";
// iterate data
;(function(){
  var $$obj = data;
  if ('number' == typeof $$obj.length) {
      for (var pug_index1 = 0, $$l = $$obj.length; pug_index1 < $$l; pug_index1++) {
        var rowData = $$obj[pug_index1];
if (rowData.hasError) {
pug_html = pug_html + "\u003Ctr class=\"grid-row error\"\u003E";
// iterate rowData.formattedValues
;(function(){
  var $$obj = rowData.formattedValues;
  if ('number' == typeof $$obj.length) {
      for (var index = 0, $$l = $$obj.length; index < $$l; index++) {
        var cellData = $$obj[index];
pug_html = pug_html + "\u003Ctd class=\"grid-cell\"\u003E\u003Cdiv class=\"grid-content-container\"\u003E";
if (index === 0) {
if (isForVNext) {
pug_html = pug_html + "\u003Cspan class=\"iconba iconba-ErrorBadge\"\u003E\u003C\u002Fspan\u003E";
}
else {
pug_html = pug_html + "\u003Cspan class=\"status_error\"\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = cellData) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
else {
pug_html = pug_html + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = cellData) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E";
      }
  } else {
    var $$l = 0;
    for (var index in $$obj) {
      $$l++;
      var cellData = $$obj[index];
pug_html = pug_html + "\u003Ctd class=\"grid-cell\"\u003E\u003Cdiv class=\"grid-content-container\"\u003E";
if (index === 0) {
if (isForVNext) {
pug_html = pug_html + "\u003Cspan class=\"iconba iconba-ErrorBadge\"\u003E\u003C\u002Fspan\u003E";
}
else {
pug_html = pug_html + "\u003Cspan class=\"status_error\"\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = cellData) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
else {
pug_html = pug_html + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = cellData) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ftr\u003E";
}
else {
pug_html = pug_html + "\u003Ctr class=\"grid-row\"\u003E";
// iterate rowData.formattedValues
;(function(){
  var $$obj = rowData.formattedValues;
  if ('number' == typeof $$obj.length) {
      for (var pug_index3 = 0, $$l = $$obj.length; pug_index3 < $$l; pug_index3++) {
        var cellData = $$obj[pug_index3];
pug_html = pug_html + "\u003Ctd class=\"grid-cell\"\u003E\u003Cdiv class=\"grid-content-container\"\u003E" + (pug.escape(null == (pug_interp = cellData) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index3 in $$obj) {
      $$l++;
      var cellData = $$obj[pug_index3];
pug_html = pug_html + "\u003Ctd class=\"grid-cell\"\u003E\u003Cdiv class=\"grid-content-container\"\u003E" + (pug.escape(null == (pug_interp = cellData) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ftr\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index1 in $$obj) {
      $$l++;
      var rowData = $$obj[pug_index1];
if (rowData.hasError) {
pug_html = pug_html + "\u003Ctr class=\"grid-row error\"\u003E";
// iterate rowData.formattedValues
;(function(){
  var $$obj = rowData.formattedValues;
  if ('number' == typeof $$obj.length) {
      for (var index = 0, $$l = $$obj.length; index < $$l; index++) {
        var cellData = $$obj[index];
pug_html = pug_html + "\u003Ctd class=\"grid-cell\"\u003E\u003Cdiv class=\"grid-content-container\"\u003E";
if (index === 0) {
if (isForVNext) {
pug_html = pug_html + "\u003Cspan class=\"iconba iconba-ErrorBadge\"\u003E\u003C\u002Fspan\u003E";
}
else {
pug_html = pug_html + "\u003Cspan class=\"status_error\"\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = cellData) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
else {
pug_html = pug_html + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = cellData) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E";
      }
  } else {
    var $$l = 0;
    for (var index in $$obj) {
      $$l++;
      var cellData = $$obj[index];
pug_html = pug_html + "\u003Ctd class=\"grid-cell\"\u003E\u003Cdiv class=\"grid-content-container\"\u003E";
if (index === 0) {
if (isForVNext) {
pug_html = pug_html + "\u003Cspan class=\"iconba iconba-ErrorBadge\"\u003E\u003C\u002Fspan\u003E";
}
else {
pug_html = pug_html + "\u003Cspan class=\"status_error\"\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = cellData) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
else {
pug_html = pug_html + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = cellData) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ftr\u003E";
}
else {
pug_html = pug_html + "\u003Ctr class=\"grid-row\"\u003E";
// iterate rowData.formattedValues
;(function(){
  var $$obj = rowData.formattedValues;
  if ('number' == typeof $$obj.length) {
      for (var pug_index5 = 0, $$l = $$obj.length; pug_index5 < $$l; pug_index5++) {
        var cellData = $$obj[pug_index5];
pug_html = pug_html + "\u003Ctd class=\"grid-cell\"\u003E\u003Cdiv class=\"grid-content-container\"\u003E" + (pug.escape(null == (pug_interp = cellData) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index5 in $$obj) {
      $$l++;
      var cellData = $$obj[pug_index5];
pug_html = pug_html + "\u003Ctd class=\"grid-cell\"\u003E\u003Cdiv class=\"grid-content-container\"\u003E" + (pug.escape(null == (pug_interp = cellData) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ftr\u003E";
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ftbody\u003E\u003C\u002Ftable\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";}.call(this,"ariaLabel" in locals_for_with?locals_for_with.ariaLabel:typeof ariaLabel!=="undefined"?ariaLabel:undefined,"columns" in locals_for_with?locals_for_with.columns:typeof columns!=="undefined"?columns:undefined,"data" in locals_for_with?locals_for_with.data:typeof data!=="undefined"?data:undefined,"isForVNext" in locals_for_with?locals_for_with.isForVNext:typeof isForVNext!=="undefined"?isForVNext:undefined));;return pug_html;};
module.exports = template;